import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

interface DividendRecord {
  id: string;
  type: 'bonus' | 'points'; // bonus: 奖金, points: 积分
  amount: number;
  description: string;
  time: string;
  status: 'plus' | 'minus'; // plus: 增加, minus: 减少
}

const Dividend: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'bonus' | 'points'>('bonus');
  const [loading, setLoading] = useState(true);
  const [dividendRecords, setDividendRecords] = useState<DividendRecord[]>([]);

  // 获取URL参数
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const nickname = urlParams.get('nickname');
  const avatar = urlParams.get('avatar');

  useEffect(() => {
    // 模拟加载数据
    setTimeout(() => {
      const mockData: DividendRecord[] = [
        {
          id: '1',
          type: 'bonus',
          amount: 100.00,
          description: '团队分红奖励',
          time: '2024-01-15 14:30:25',
          status: 'plus'
        },
        {
          id: '2',
          type: 'bonus',
          amount: 50.00,
          description: '直推奖励',
          time: '2024-01-14 09:15:10',
          status: 'plus'
        },
        {
          id: '3',
          type: 'bonus',
          amount: 20.00,
          description: '提现手续费',
          time: '2024-01-13 16:45:30',
          status: 'minus'
        },
        {
          id: '4',
          type: 'points',
          amount: 500,
          description: '签到奖励积分',
          time: '2024-01-15 08:00:00',
          status: 'plus'
        },
        {
          id: '5',
          type: 'points',
          amount: 200,
          description: '积分兑换商品',
          time: '2024-01-12 11:20:15',
          status: 'minus'
        },
        {
          id: '6',
          type: 'points',
          amount: 100,
          description: '活动奖励积分',
          time: '2024-01-10 19:30:45',
          status: 'plus'
        }
      ];
      //setDividendRecords(mockData);
      setLoading(false);
    }, 1000);
  }, []);

  const handleBack = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const nickname = urlParams.get('nickname');
    const avatar = urlParams.get('avatar');
    const balance = urlParams.get('balance');
    
    const vipUrl = `/vip?token=${token}&nickname=${nickname}&avatar=${avatar}&balance=${balance}`;
    navigate(vipUrl);
  };

  const filteredRecords = dividendRecords.filter(record => record.type === activeTab);

  const renderRecordItem = (record: DividendRecord) => (
    <div key={record.id} className="record-item">
      <div className="record-main">
        <div className="record-amount">
          <span className={`amount-sign ${record.status}`}>
            {record.status === 'plus' ? '+' : '-'}
          </span>
          <span className="amount-value">
            {record.type === 'bonus' ? `¥${record.amount.toFixed(2)}` : record.amount}
          </span>
        </div>
        <div className="record-info">
          <div className="record-description">{record.description}</div>
          <div className="record-time">{record.time}</div>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="dividend-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <div className="loading-text">加载中...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="dividend-container">
      {/* 页面头部 */}
      <div className="page-header">
        <div className="section-header">
          <h2>分红明细</h2>
          <button className="back-btn" onClick={handleBack}>
            ← 返回
          </button>
        </div>
      </div>

      {/* 标签页 */}
      <div className="tab-section">
        <div className="level-tabs">
          <button
            className={`level-tab ${activeTab === 'bonus' ? 'active' : ''}`}
            onClick={() => setActiveTab('bonus')}
          >
            奖金明细
          </button>
          <button
            className={`level-tab ${activeTab === 'points' ? 'active' : ''}`}
            onClick={() => setActiveTab('points')}
          >
            积分明细
          </button>
        </div>
      </div>

      {/* 记录列表 */}
      <div className="records-section">
        {filteredRecords.length > 0 ? (
          <div className="records-list">
            {filteredRecords.map(renderRecordItem)}
          </div>
        ) : (
          <div className="empty-list">
            <div className="empty-icon">💸</div>
            <div className="empty-text">
              暂无{activeTab === 'bonus' ? '奖金' : '积分'}明细
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dividend; 